<template>
    <div class="tjks" v-loading.fullscreen.lock="loading">
        <div class="main">
            <div class="option">
                科室编码:
                <div style="width: 60%; margin-left: 40px">
                    <el-input placeholder="科室编码" v-model="code"></el-input>
                </div>
            </div>
            <div class="option">
                科室名称:
                <div style="width: 60%; margin-left: 40px">
                    <el-input placeholder="科室名称" v-model="name"></el-input>
                </div>
            </div>
            <div class="button">
                <el-button @click="addKs">添加科室</el-button>
                <el-button @click="goback">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { divAdd } from '@/api/div.js'
    export default {
        data() {
            return {
                loading: false,
                code: "",
                name: "",
                form: {
                    km: "",
                },
            };
        },
        created() { },
        methods: {
            addKs() {
                if (this.code == "") {
                    this.$message.error("请输入科室编码!");
                } else if (this.name == "") {
                    this.$message.error("请输入科室名称");
                } else {
                    this.loading = true;
                    divAdd({
                            code: this.code,
                            name: this.name,
                            type: 1, //type:1 为科室
                        })
                        .then((res) => {
                            if (res.status == 0) {
                                this.$message.success("添加成功!");
                                this.code = "";
                                this.name = "";
                            }
                            this.loading = false;
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                }
            },
            goback() {
                this.$router.push({ name: '科室列表' })
            },
        },
    };
</script>

<style scoped>
    .tjks {
        height: 500px;
        width: 80%;
        margin: 0 auto;
        margin-top: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .tjks .main {
            height: 400px;
            width: 50%;
        }

            .tjks .main .option {
                height: 80px;
                margin: 10px 0;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 55px !important;
                font-size: 20px !important;
                font-weight: 500 !important;
                font-family: fangsong !important;
            }

    .button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>